import {Component} from '@angular/core';

@Component({
  templateUrl: './logs.component.html'
})
export class LogsComponent {
  constructor() {
  }
}
